import { getModule } from "@companion-core/shared/app/Utils/config";

export const getCategoryNameFromFamily = ({
  family,
  subfamily,
}: {
  family: string;
  subfamily?: string;
}): string | undefined => {
  const categoryByFamilyAndSubfamily =
    getModule("concierge")?.modules?.bell?.options?.categoryNameByFamily ?? {};

  const categoryName: string | undefined = categoryByFamilyAndSubfamily[family]
    ? (categoryByFamilyAndSubfamily[family][subfamily ?? "other"] ??
      categoryByFamilyAndSubfamily[family]["default"])
    : undefined;

  return categoryName;
};
